import { defineTokens } from '@chakra-ui/react'

import { fontFamilies } from '../fontFamilies'

// Nothing defines --font-sans/--font-mono, so tokens must name the real
// families (their @font-face rules come from Fonts.tsx via DarkProvider).
export const fonts = defineTokens.fonts({
  heading: { value: fontFamilies.soehne },
  body: { value: fontFamilies.soehne },
  mono: { value: fontFamilies.soehneMono },
})
